import styled from "styled-components";

export default function AboutUs(){
    return(
        <Content>
                <p>O SPC Escola nasceu para oferecer às instituições de ensino uma solução moderna, segura e altamente eficaz no combate à inadimplência. Criado pela Câmara de Dirigentes Lojistas do Rio de Janeiro, o sistema integra escolas de todo o país ao SPC Brasil, o maior banco de dados da América Latina, trazendo ao setor educacional um instrumento sólido de proteção ao crédito – já amplamente utilizado pelo comércio e agora totalmente adaptado à realidade escolar.</p>
                <p>Durante muitos anos, o desconhecimento sobre os limites legais da cobrança impediu escolas, faculdades e cursos de utilizarem recursos legítimos para reduzir a inadimplência. A ausência de orientação jurídica fazia com que muitas instituições acreditassem que nada podiam fazer diante de mensalidades em atraso, arcando com custos elevados em advogados e sistemas de cobrança pouco eficientes.</p>
                <p>O SPC Escola veio para mudar esse cenário.</p>
                <h2>O que fazemos?</h2>
                <p>Através de um processo totalmente legal, simples e transparente, o SPC Escola permite que o débito seja registrado no CPF do responsável financeiro, sem gerar qualquer constrangimento ao aluno. A legislação é clara: não se pode prejudicar o estudante com suspensão de provas ou documentos — mas nada impede que o responsável inadimplente tenha sua dívida registrada em bancos de dados de crédito.</p>
                <p>Com essa ferramenta, as instituições ganham agilidade, economia e segurança para recuperar seus créditos, enquanto os responsáveis têm a chance de regularizar sua situação antes que o débito evolua para ações judiciais mais complexas e custosas.</p>
                <h2>Por que o SPC Escola é diferente?</h2>
                <p>Ao contrário de outros bancos de dados com foco restrito ao sistema financeiro, o SPC Brasil oferece a maior capilaridade do varejo nacional. Isso significa que, uma vez inscrito, o responsável inadimplente enfrenta limitações reais no comércio e serviços do país, o que fortalece a seriedade do compromisso financeiro com a instituição de ensino.</p>
                <p>Além disso, o SPC Escola já reúne centenas de escolas, faculdades, universidades, creches e cursos profissionalizantes, ampliando ainda mais a efetividade das restrições e a recuperação dos créditos.</p>
                <h2>Benefícios para a Instituição de Ensino:</h2>
                <ul>
                    <li>Redução imediata da inadimplência.</li>
                    <li>Registro de devedores diretamente pelo usuário, sem burocracia.</li>
                    <li>Notificação automática ao responsável, com prazo para negociação.</li>
                    <li>Economia com processos judiciais e cobranças externas.</li>
                    <li>Acesso ao amplo banco de dados do SPC Brasil.</li>
                    <li>Consultas cadastrais completas e atualizadas.</li>
                    <li>Integração com serviços exclusivos da Câmara Rio, como VOIP, isenção de custas de protesto, consultoria jurídica e tributária e muito mais.</li>
                </ul>
                <h2>Quem pode utilizar?</h2>
                <ul>
                    <li>Escolas de ensino fundamental e médio</li>
                    <li>Faculdades e universidades</li>
                    <li>Cursos técnicos, livres e profissionalizantes</li>
                    <li>Pré-vestibulares</li>
                    <li>Escolas de idiomas</li>
                    <li>Creches e jardins de infância</li>
                    <li>Cursos de tecnologia e informática</li>
                </ul>
                <p>Se a sua instituição oferece educação, o SPC Escola pode — e deve — fazer parte da sua estratégia financeira.</p>
                <h2>Nossa missão</h2>
                <p>Apoiar instituições de ensino, garantindo sustentabilidade financeira, segurança jurídica e ferramentas eficazes de proteção ao crédito, sem jamais comprometer a integridade pedagógica do aluno.</p>
                <h2>Nosso compromisso</h2>
                <p>Seguimos a legislação, respeitamos o estudante e fortalecemos a relação entre escolas e famílias, garantindo que ambas as partes tenham clareza, responsabilidade e soluções acessíveis.</p>
        </Content>
    )
}

const Content = styled.div`
    max-width: 900px;
    margin: 0 auto;
    padding: 40px 20px;

    font-family: 'Poppins', sans-serif;
    line-height: 1.7;
    color: #264b91;

    h2 {
        font-size: 1.8rem;
        margin-top: 40px;
        margin-bottom: 15px;
        color: #1e3d78;
        font-weight: 600;
        position: relative;
    }

    h2::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: -5px;
        width: 60px;
        height: 3px;
        background: #1e3d78;
        border-radius: 3px;
    }

    p {
        font-size: 1.1rem;
        margin-bottom: 20px;
        text-align: justify;
    }

    ul {
        margin: 20px 0;
        padding-left: 25px;
    }

    ul li {
        margin-bottom: 10px;
        font-size: 1.05rem;
        position: relative;
    }

    ul li::before {
        content: "•";
        position: absolute;
        left: -18px;
        color: #1e3d78;
        font-weight: bold;
    }

    @media (max-width: 768px) {
        padding: 20px;
        
        h2 {
            font-size: 1.5rem;
        }

        p, ul li {
            font-size: 1rem;
        }
    }
`;
